import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { publicRequest } from "../api/requestMethods";

export const fetchBlogPosts = createAsyncThunk(
  "blog/fetchPosts",
  async ({ category, page = 1, limit = 12 } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ page, limit });
      if (category) params.append("category", category);
      const res = await publicRequest.get(`/api/blog/posts?${params}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch posts");
    }
  }
);

export const fetchBlogPostBySlug = createAsyncThunk(
  "blog/fetchPostBySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const res = await publicRequest.get(`/api/blog/posts/${slug}`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Post not found");
    }
  }
);

const blogSlice = createSlice({
  name: "blog",
  initialState: {
    posts: [],
    total: 0,
    currentPage: 1,
    selectedPost: null,
    isFetching: false,
    isFetchingPost: false,
    error: null,
  },
  reducers: {
    clearSelectedPost: (state) => {
      state.selectedPost = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogPosts.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchBlogPosts.fulfilled, (state, action) => {
        state.isFetching = false;
        state.posts = action.payload.data;
        state.total = action.payload.total;
        state.currentPage = action.payload.page;
      })
      .addCase(fetchBlogPosts.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      })
      .addCase(fetchBlogPostBySlug.pending, (state) => {
        state.isFetchingPost = true;
        state.error = null;
      })
      .addCase(fetchBlogPostBySlug.fulfilled, (state, action) => {
        state.isFetchingPost = false;
        state.selectedPost = action.payload;
      })
      .addCase(fetchBlogPostBySlug.rejected, (state, action) => {
        state.isFetchingPost = false;
        state.error = action.payload;
      });
  },
});

export const { clearSelectedPost } = blogSlice.actions;
export default blogSlice.reducer;
